import React, { useState } from 'react';
import { Dashboard } from './pages/Dashboard';
import { Sidebar } from './components/Sidebar';
export function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  return <div className="w-full min-h-screen bg-gray-50 flex" data-id="element-0">
      <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} data-id="element-1" />
      <div className={`flex-1 transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-16'}`} data-id="element-2">
        <Dashboard data-id="element-3" />
      </div>
    </div>;
}